'use client'
import { useState } from 'react';
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import customHeaders, { getSpace } from '../../common/headers';
import useGeneralStore from '../../store/general';
import { Sceleton, TableBox, Tabs, CheckboxToggle } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import './TariffPlan.scss';
import AddBalanceModal from '../AddBalanceModal';
import { useEffect } from 'react';
import { TitlePage } from '../TitlePage/TitlePage';
import { ModalTariffActivate } from './ModalTariffActivate/ModalTariffActivate';
import { Payment } from '../../pages/Payment/Payment';
import TariffPlanV2 from './TariffPlanV2/TariffPlanV2';
import dayjs from 'dayjs';
import { useResponseHandler } from '../../common/auth';
import { MoonLoader } from 'react-spinners';
import { StepItem } from '../StepItem/StepItem';
import { useShallow } from 'zustand/react/shallow';
import { usePushNotifications } from '../../common/pushNotification';

const btn_tab = [
  { label: 'Тарифы', value: 'tariffs' },
  { label: 'Остатки по лимитам', value: 'remaining_limits' }
];

function getCurrentMonth() {
  const date = new Date();
  return date.toLocaleString('ru-RU', { month: 'long' });
}

const TariffPlan = () => {

  const {
    selectedSpace,
    statusTariff,
    setStatusTariff,
    tariffInSpace,
    setTariffInSpace,
    isPending,
    setisPending
  } = useGeneralStore(
    useShallow((state) => ({
      selectedSpace: state.selectedSpace,
      statusTariff: state.statusTariff,
      setStatusTariff: state.setStatusTariff,
      tariffInSpace: state.tariffInSpace,
      setTariffInSpace: state.setTariffInSpace,
      isPending: state.isPending,
      setisPending: state.setisPending,
    }))
  );

  const activeTab = useParams()['*']
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const { addErrorPush, addSuccessPush } = usePushNotifications();
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const [isModalBalance, setIsModalBalance] = useState(false);
  const [modelsTariff, setIsModelsTariff] = useState([])
  // const [tariffInSpace, setTariffInSpace] = useState([])

  const [currentTariffActivate, setCurrentTariffActivate] = useState(null)
  const [pageValue, setPageValue] = useState(btn_tab[0].value);

  // Таблица
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort, setCustomHeaders } = setTableFuncs;

  const btns = [
    {
      label: '1 Месяц',
      value: 1
    },
    {
      label: <>3 месяца <div className="discount">10 %</div></>,
      value: 3
    },
    {
      label: <>6 месяцев <div className="discount">15 %</div></>,
      value: 6
    },
    {
      label: <>12 месяцев <div className="discount">20 %</div></>,
      value: 12
    },
  ]
  const [status, setStatus] = useState(btns?.[0]?.value)
  const [currentPlan, setCurrentPlan] = useState()
  const [turnover, setTurnover] = useState(null)
  const [loadingTurnover, setLoadingTurnover] = useState(false)
  // const [isPending, setisPending] = useState(false)
  const [pendingTariff, setPendingTariff] = useState(false)
  const [isAutomaticExtension, setIsAutomaticExtension] = useState(false)
  const [addedSum, setAddedSum] = useState(0)

  // Получение моделей тарифов
  const fetchGetModelsTariff = (period) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/models?portal_id=1&period=${period}`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => setIsModelsTariff(json))
      .catch(handleRequestError)
      .finally(() => { });
  };

  // Активация модели тарифа
  const fetchActivateModelsTariff = (id) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/activate`

    const body = JSON.stringify({
      id: id
    })

    fetch(url, { method: 'POST', body, headers })
      .then(handleTableResponse)
      .then(handleTableResponse)
      .then(json => {
        setTimeout(() => {
          fetchGetModelsTariffInSpace()
          fetchGetModelsTariff()
        }, 500)

        setTimeout(() => {
          fetchGetModelsTariffInSpace()
        }, 8000)
      })
      .catch(err => {
        alert(`Ошибка активации: ${'у вас уже есть неактивированный тариф'}`);
        console.error(err);
      })
  }

  // Получение тарифов пространства
  const fetchGetModelsTariffInSpace = (id) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/info`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => {
        setTariffInSpace(json)
        setIsAutomaticExtension(json?.is_auto_renewal)
      })
      .catch(handleRequestError)
  }

  // Тогл автопродление тарифа
  const fetchStatusAutoExtension = (status) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/auto-renewal`;

    const body = JSON.stringify({
      is_auto_renewal: status
    })

    fetch(url, { method: 'PATCH', headers, body })
      .then(handleTableResponse)
      .then((json) => {
        setTimeout(() => fetchGetModelsTariffInSpace(), 1000)
        addSuccessPush(`Автоматическое продление тарифа ${json?.is_auto_renewal ? 'активировано' : 'деактивировано'}`)
      })
      .catch(handleRequestError)
      .finally(() => { });
  }

  // Получение оборота
  const fetchGetTurnover = () => {
    setLoadingTurnover(true)
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/turnover`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => setTurnover(json))
      .catch(handleRequestError)
      .finally(() => setLoadingTurnover(false));
  }

  // Статус тарифа
  const fetchGetstatus = () => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/active/status`;

    fetch(url, { method: 'GET', headers, })
      .then(handleTableResponse)
      .then((json) => setStatusTariff(json?.has_active))
      .catch(handleRequestError)
  }

  // Удалить тарифф
  const fetchDeleteTariff = (id) => {
    const url = `https://apps0.ecomru.ru:4453/api/v1/tariff/${id}`;

    const body = JSON.stringify({})

    fetch(url, { method: 'DELETE', headers, body })
      .then(async res => {
        if (res.ok) {
          return res.json()
        } else {
          const err = await res.json()
          throw new Error(JSON.stringify(err))
        }
      })
      .then(json => {
        setTimeout(() => fetchGetModelsTariffInSpace(), 1500)
      })
      .catch(err => {
        console.error(err);
      })
  }

  // Таблица товаров для ИИ анализа
  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam = [];

    if (params) {
      [sort, filtersParam] = params;
    }

    // Устанавливаем loading в true только если запрос не прерван
    if (!abortController.signal.aborted) {
      setLoading(true);
    }

    let url = `https://apps0.ecomru.ru:4420/api/v1/tariff/service/limits${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''}`;

    const body = JSON.stringify({
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
      filters: filtersParam
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const err = await res.json();
          throw new Error(JSON.stringify(err));
        }
      })
      .then((json) => {
        setTable(json);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    if (pageValue === 'remaining_limits') {
      const abortController = new AbortController()
      fetchTableData([], abortController)
      return () => abortController.abort()
    }
  }, [pageValue]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      fetchGetModelsTariffInSpace()
    }, 30000) // 30 секунд

    return () => clearInterval(intervalId)
  }, []);

  useEffect(() => {
    fetchGetModelsTariff(status)
  }, [status]);

  useEffect(() => {
    fetchGetTurnover()
    fetchGetstatus()
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window?.location?.search);
    const pricePlan = queryParams.get('ref-pricePlan');
    if (pricePlan) {
      setCurrentPlan(pricePlan)
    }
    localStorage.removeItem('ref-pricePlan')
    localStorage.removeItem('ref-page')
  }, [window?.location?.search]);

  useEffect(() => {
    setPageValue(activeTab)
  }, [activeTab])

  const returnStatus = (status) => {
    if (status === 'active') {
      return ['Активен', 'tariffs-plan-2__status-active']
    }
    if (status === 'awaiting_payment') {
      return ['Ждет оплаты', 'tariffs-plan-2__status-pending']
    }
    if (status === 'not_found') {
      return ['Неактивен', 'tariffs-plan-2__status-disactive']
    }
  }

  // Выручка: сравнение с прошлым месяцем
  const currentRevenue = Number(turnover?.current_month) || 0
  const previousRevenue = Number(turnover?.previous_month) || 0
  const hasPreviousRevenue = previousRevenue > 0
  const revenueProgress = hasPreviousRevenue ? Math.min(100, Math.round((currentRevenue / previousRevenue) * 100)) : 0
  const revenueDelta = hasPreviousRevenue ? ((currentRevenue - previousRevenue) / previousRevenue) * 100 : 0
  const revenueDeltaText = `${revenueDelta >= 0 ? '+' : '−'}${Math.abs(revenueDelta).toFixed(1).replace('.', ',')}%`

  // Шкала тарифа: сколько дней прошло / осталось (только для отображения)
  const planTariff = tariffInSpace?.tariff
  const planStart = planTariff?.date_start ? dayjs(planTariff.date_start) : null
  const planEnd = planTariff?.date_end ? dayjs(planTariff.date_end) : null
  const showPlanScale = Boolean(planTariff?.is_active && planStart?.isValid() && planEnd?.isValid())
  const planTotalDays = showPlanScale ? planEnd.diff(planStart, 'day') : 0
  const planDaysLeft = showPlanScale
    ? (tariffInSpace?.days_left ?? Math.max(0, planEnd.diff(dayjs(), 'day')))
    : 0
  const planProgress = planTotalDays > 0
    ? Math.min(100, Math.max(0, Math.round(((planTotalDays - planDaysLeft) / planTotalDays) * 100)))
    : 0

  const daysWord = (n) => {
    const m10 = n % 10
    const m100 = n % 100
    if (m10 === 1 && m100 !== 11) return 'день'
    if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return 'дня'
    return 'дней'
  }

  return (
    <>

      <TitlePage
        title='Тарифы'
      />

      <div className='tariffs-plan-2__dcont'>
        <Payment />

        <div className="revenue-card"
          style={{ padding: loadingTurnover ? '0' : '' }}
        >
          {loadingTurnover ?
            <div className="tariff-plan__loader">
              <Sceleton
                width={'100%'}
                height={'100%'}
              />
            </div>
            :
            <>
              <div className="revenue-card__head">
                <div className="revenue-card__label">Выручка · {getCurrentMonth()}</div>

                {hasPreviousRevenue &&
                  <span
                    className={`revenue-card__chip ${revenueDelta >= 0 ? 'revenue-card__chip_up' : 'revenue-card__chip_down'}`}
                    title="К прошлому месяцу"
                  >
                    {revenueDeltaText}
                  </span>
                }
              </div>

              <div className="revenue-card__sum-box">
                {turnover?.current_month?.toLocaleString()} ₽
              </div>

              <div className="revenue-card__progress-box">
                {hasPreviousRevenue &&
                  <div className="revenue-card__progress">
                    <div className="revenue-card__progress-bar" style={{ width: `${revenueProgress}%` }} />
                  </div>
                }
                <div className="revenue-card__progress-info">
                  <span>{getCurrentMonth().charAt(0).toUpperCase() + getCurrentMonth().slice(1)}: <b>{turnover?.current_month?.toLocaleString()} ₽</b></span>
                  <span>Пред. месяц: <b>{turnover?.previous_month?.toLocaleString()} ₽</b></span>
                </div>
              </div>
            </>
          }

        </div>
      </div>



      <div className="tariffs-plan-2">
        {isModalBalance &&
          <AddBalanceModal
            addedSum={addedSum}
            setIsModalActive={() => setIsModalBalance(false)}
          />
        }

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
        />

        {isPending && <div className="tariffs-plan-2__info">
          <StepItem
            title={<>У вас есть неоплаченный тариф <span className='tariffs-plan-2__tariff-name'>"{pendingTariff?.portal_name}."</span> Пополните баланс.</>}
          />
        </div>}

        {(tariffInSpace?.days_left && (tariffInSpace?.days_left < 8)) && <div className="tariffs-plan-2__info">
          <StepItem
            title={`До окончания тарифа осталось ${tariffInSpace?.days_left} дней. 
              ${tariffInSpace?.required_topup ? `Пополните баланс на ${tariffInSpace?.required_topup} руб.` : ''}`}
          />
        </div>}

        {pageValue === 'remaining_limits' && <TableBox
          {...tableProps}
          paginator={true}
          ref={paginatorRef}
          fetchCallback={fetchTableData}
        />}

        {pageValue === 'tariffs' && <TariffPlanV2
          setAddedSum={setAddedSum}
          fetchGetActivateTariff={fetchGetModelsTariffInSpace}
          setIsModalBalance={setIsModalBalance}
          child={
            <>
              <div className="tariffs-plan-2__header">
                {/* <span className={`tariffs-plan-2__status-big${statusTariff ? '_green' : '_red'}`}>{statusTariff ? 'Активен' : 'Не активен'}</span> */}

                <div className="current-plan">
                  <div className="current-plan__head">
                    <span className="current-plan__label">Ваш тариф: </span>
                    {tariffInSpace ?
                      <>
                        <span className="current-plan__name">{tariffInSpace?.tariff?.portal_name || 'Не выбран'}</span>
                        <span className={`current-plan__status ${returnStatus(tariffInSpace?.status)?.[1]}`}>
                          {returnStatus(tariffInSpace?.status)?.[0]}
                        </span>
                      </>
                      : <span className="current-plan__name">Не выбран</span>
                    }
                  </div>

                  {showPlanScale &&
                    <div className="current-plan__scale">
                      <div className="current-plan__bar">
                        <div className="current-plan__bar-fill" style={{ width: `${planProgress}%` }} />
                      </div>
                      <div className="current-plan__dates">
                        <span>{planStart.format('DD-MM-YY')}</span>
                        <span>Осталось {planDaysLeft} {daysWord(planDaysLeft)}</span>
                        <span>{planEnd.format('DD-MM-YY')}</span>
                      </div>
                    </div>
                  }

                  {tariffInSpace?.tariff?.portal_name && <CheckboxToggle
                    text={'Автоматическое продление тарифа'}
                    value={isAutomaticExtension}
                    onChange={(e) => {
                      setIsAutomaticExtension(!isAutomaticExtension)
                      fetchStatusAutoExtension(!isAutomaticExtension)
                    }}
                  />}
                </div>


              </div>
            </>
          }
        />}
      </div >
    </>
  );
};

export { TariffPlan };
